module.exports = __webpack_public_path__ + "static/media/champagne@2x.eb538ee6.png";